import { useIsFetching } from '@tanstack/react-query';
import { TREE_CATEGORIES } from '@elementary/common-ui/constants/queryKeys';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';

const useIsTreeViewLoading = () => {
  const selectedEnvId = useSelectedEnv();

  const isFetching = useIsFetching({
    queryKey: [selectedEnvId, TREE_CATEGORIES],
  });

  return isFetching > 0;
};

export default useIsTreeViewLoading;
